import React, { PureComponent } from 'react';
import { Provider } from 'react-redux';
import TopBar from './TopBar';
import { updateLogo } from '../../reducers/setConfig';

class Header extends PureComponent {
  constructor(props) {
    super(props)

    this.state = { ...props }
  }

  componentDidMount() {
    store.dispatch(updateLogo);
  }

  render() {
    return (
      <Provider store={store}>
        {/* eslint-disable-next-line react/destructuring-assignment */}
        <TopBar email={this.state.email} />
      </Provider>
    );
  }
}

export default Header;
